import { render } from "./FishMeter.vue?vue&type=template&id=bd81d80c&scoped=true"
import script from "./FishMeter.vue?vue&type=script&lang=js"
export * from "./FishMeter.vue?vue&type=script&lang=js"

import "./FishMeter.vue?vue&type=style&index=0&id=bd81d80c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd81d80c"]])

export default __exports__